<div class="app-new-withdrawal" [ngClass]="httpService.theme">
    <div class="field mt-2">
        <cf-checkbox-large [options]="withdrawal_type_options" label="Select" [theme]="httpService.theme"
            (changed)="changeWithdrawalType($event)"></cf-checkbox-large>
    </div>

    <app-new-withdrawal-investment *ngIf="selected_withdrawal_type === 'investment'"
        [pool_id]="pool_id"></app-new-withdrawal-investment>
    <app-new-earning *ngIf="selected_withdrawal_type === 'earnings'" [pool_id]="pool_id"></app-new-earning>
</div>